export const POSTS_REQUEST = 'POSTS_REQUEST'
export const POSTS_SUCCESS = 'POSTS_SUCCESS'
export const POSTS_FAIL = 'POSTS_FAIL'

export const LATEST_POSTS_REQUEST = 'LATEST_POSTS_REQUEST'
export const LATEST_POSTS_SUCCESS = 'LATEST_POSTS_SUCCESS'
export const LATEST_POSTS_FAIL = 'LATEST_POSTS_FAIL'

export const POST_REQUEST = 'POST_REQUEST'
export const POST_SUCCESS = 'POST_SUCCESS'
export const POST_FAIL = 'POST_FAIL'

export const COMMENT_REQUEST = 'COMMENT_REQUEST'
export const COMMENT_SUCCESS = 'COMMENT_SUCCESS'
export const COMMENT_FAIL = 'COMMENT_FAIL'
export const COMMENT_RESET = 'COMMENT_RESET'

export const READ_LATER_ADD = 'READ_LATER_ADD'
export const READ_LATER_REMOVE = 'READ_LATER_REMOVE'

export const SUBSCRIBE_REQUEST = 'SUBSCRIBE_REQUEST'
export const SUBSCRIBE_SUCCESS = 'SUBSCRIBE_SUCCESS'
export const SUBSCRIBE_FAIL = 'SUBSCRIBE_FAIL'
export const SUBSCRIBE_RESET = 'SUBSCRIBE_RESET'

export const UNSUBSCRIBE_REQUEST = 'UNSUBSCRIBE_REQUEST'
export const UNSUBSCRIBE_SUCCESS = 'UNSUBSCRIBE_SUCCESS'
export const UNSUBSCRIBE_FAIL = 'UNSUBSCRIBE_FAIL'
